export const CCUFSA_EVENT = {
  name: '2026 CCUFSA National Conference',
  date: 'June 23 – 28, 2026',
  dateShort: 'Jun 23–28, 2026',
  startISO: '2026-06-23',
  endISO: '2026-06-28',
  conferenceDays: 'June 24 – 27',
  city: 'Ottawa',
  province: 'Ontario',
  venue: 'Delta Hotels Ottawa City Centre',
  address: '101 Lyon St. N, Ottawa, ON K1R 5T9',
  link: 'https://site.pheedloop.com/event/ccufsa2026/home',
  ccufsaSite: 'https://ccufsa.com/',
  ccufsaLogo: 'https://static.pheedloop.com/media/events/EVEESQDIIZLTL/files/vFDxCiSj_882952.png',
  hashtag: '#CCUFSA2026',
  description: "Don't miss this opportunity to connect, learn, and explore the future of campus food services.",
  highlights: [
    { title: 'Olympic Keynote', body: 'An inspiring keynote from Gold Medal Olympian Heather Moyse.' },
    { title: 'Nutrition & Wellness Forum', body: 'Deep-dive sessions on the next chapter of campus nutrition.' },
    { title: "Chef's Culinary Competition", body: 'Live at Algonquin College — watch Canada\'s best campus chefs compete.' },
    { title: '75+ Vendor Trade Show', body: 'Walk the annual trade show floor with 75+ foodservice vendors.' },
    { title: 'Capital Golf Experience', body: 'Tee off in Ottawa with a scenic golf afternoon.' },
    { title: 'Networking Receptions', body: 'Five evenings of dinners, receptions and Canadian hospitality.' }
  ],
  sponsorBands: [
    { tier: 'Diamond', logos: [
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOP6OSA1S2WIZXRA/28258_Alto-Shaam-logo-CMYK-black_3.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPORKFYFP31GTI37D/137472_Bunge_RGB_PNG_Logo.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOOF3QBV8JF8K3PO/724168_logo-1772202881222.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOSNYM0CRTX689TI/972167_logo-1774375897858.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOCTWMKAHS32DLLC/664397_logo-1772044907815.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOK5MEV0T2SKU1FZ/388374_Tim_Hortons_Logo.jpg'
    ]},
    { tier: 'Platinum', logos: [
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPO1QHHFO6AHKLFKN/898112_getcracking_vert_bil_rgb.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPO9MNEJO9TOWR1PE/548894_logo-1778681676570.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOZNAQWAIX23ZICP/984993_Bel_Canada_with_4_logos.png'
    ]},
    { tier: 'Gold', logos: [
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOCQ5W898PSCCTSM/651407_Canada_Beef_Logo.jpg',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOB27NCJ44KGK0QJ/66144_logo-1774375973759.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOT0RLC65E2QSA87/286946_logo-1772296637821.png',
      'https://static.pheedloop.com/media/events/EVEKBSTRJOCTK/sponsors/SPOTSTLHUZB5DMGME/119148_logo-1778681857954.png'
    ]}
  ]
};

export const VDBF_EVENTS = [
  {
    id: 'ccufsa-2026',
    upcoming: true,
    name: CCUFSA_EVENT.name,
    date: CCUFSA_EVENT.date,
    city: `${CCUFSA_EVENT.city}, ${CCUFSA_EVENT.province}`,
    booth: 'Booth #142 • Trade Show Floor',
    link: CCUFSA_EVENT.link
  },
  {
    id: 'naca-live',
    upcoming: true,
    name: 'NACA Live 2026',
    date: 'February 14–17, 2026',
    city: 'Louisville, KY',
    booth: 'Tasting Lounge',
    link: '#'
  },
  {
    id: 'natural-products-expo',
    upcoming: true,
    name: 'Natural Products Expo West',
    date: 'March 10–14, 2026',
    city: 'Anaheim, CA',
    booth: 'Pavilion 17 • Hot Products',
    link: '#'
  },
  {
    id: 'nacufs',
    upcoming: false,
    name: 'NACUFS National Conference',
    date: 'July 2025',
    city: 'Minneapolis, MN',
    booth: 'Recap available on request',
    link: '#'
  }
];
